// extracted by mini-css-extract-plugin
module.exports = {"withBorder":"collapsibleSubCategory_withBorder__M9FYq","header":"collapsibleSubCategory_header__t9XM4","content":"collapsibleSubCategory_content__0PVa3"};